import { armorAPI } from '~/services/api';
import { type JSONCustomsDeclarationPayload } from '~/types/CustomsDeclaration';
import {
  type JSONBatchEntriesCustomsItems,
  type JSONCustomsItemPayload,
} from '~/types/CustomsItem';

const createCustomsItem = (batchEntryIds: number[], customsItems: JSONCustomsItemPayload[]) =>
  armorAPI.request({
    data: {
      batch_entries: batchEntryIds,
      customs_items: customsItems,
    },
    method: 'POST',
    url: '/batch_entry/customs_items',
  });

const updateCustomsItem = (batchEntryIds: number[], customsItem: JSONCustomsItemPayload) =>
  armorAPI.request({
    data: {
      batch_entries: batchEntryIds,
      customs_items: [customsItem],
    },
    method: 'PUT',
    url: '/batch_entry/customs_items',
  });

const deleteCustomsItems = (batchEntryIds: number[], customsItems: JSONCustomsItemPayload[]) =>
  armorAPI.request({
    data: {
      batch_entries: batchEntryIds,
      customs_items: customsItems,
    },
    method: 'DELETE',
    url: '/batch_entry/customs_items/',
  });

const getCustomsItems = (batchEntryIds: number[]) =>
  armorAPI.request<JSONBatchEntriesCustomsItems>({
    method: 'GET',
    params: { batch_entry_ids: batchEntryIds },
    url: '/batch_entry/customs_items',
  });

const updateCustomsDeclaration = (
  batchEntryIds: number[],
  customsDeclaration: JSONCustomsDeclarationPayload,
) =>
  armorAPI.request({
    data: {
      batch_entries: batchEntryIds,
      customs_declaration: customsDeclaration,
    },
    method: 'PUT',
    url: '/batch_entry/customs_declaration',
  });

export {
  createCustomsItem,
  deleteCustomsItems,
  getCustomsItems,
  updateCustomsDeclaration,
  updateCustomsItem,
};
